<template>
  <v-timeline-item
    :icon="get_icon(message)"
    :icon-color="get_icon_color(message)"
    color="primary"
  >
    <v-card
      :loading="message.status == 1"
    >
      <v-card-title>
        {{ engine == null ? issi : ""}}
        <Status
          v-if="engine != null"
          class="float-right"
          :engine="engine"
          :replace_status_with_displayName="true"
        ></Status>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="copy_message(message)"
        >
          <v-icon
          >
            mdi-arrow-right-bold
          </v-icon>
        </v-btn>
        <v-btn
          icon
          @click="delete_message(message)"
        >
          <v-icon
            color="primary"
          >
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        {{ timestamp }}
      </v-card-subtitle>
      <v-card-text>
        {{ message.text }}
      </v-card-text>
    </v-card>
  </v-timeline-item>
</template>

<script>
import Status from "../Tableau/Status";
export default {
  name: "Postfach_Message",
  components: { Status },
  props: ["message"],
  computed: {
    issi(){
      let issi = this.message.srcSSI
      if (this.message.srcSSI == this.$store.state.device.issi){
        issi = this.message.destSSI
      }
      return issi
    },
    engine() {
      let engine = this.$store.getters.get_engine(this.issi)
      if(engine == null){
        this.$store.dispatch("update", { "context": "/engines/" + this.issi  })
        return null
      }
      return engine
    },
    timestamp(){
      return this.formate_time(this.message.timestamp)
    },
    get_message_title(){
      if(this.engine == null){
        return this.issi
      }
      return this.engine.display_name
    },
  },
  methods: {
    read_message(message){
      this.$store.dispatch("update", {"context": "/messages/" + message.id + "/read" })
    },
    copy_message(message){
      this.$parent.$parent.new_sds.text = message.text
    },
    delete_message(message){
      this.$store.dispatch("update", { "payload_type": "DELETE", "context": "/messages/" + message.id })
    },
    formate_time(timestamp) {
        let date = new Date(timestamp * 1000)
        let hh = date.getHours();
        let mm = date.getMinutes();
        let ss = date.getSeconds();

        hh = (hh < 10) ? "0" + hh : hh;
        mm = (mm < 10) ? "0" + mm : mm;
        ss = (ss < 10) ? "0" + ss : ss;

        return hh + ":" + mm + ":" + ss + " Uhr";
      },
    get_icon(message){
      if (message.system_message){
        return "mdi-cog-transfer-outline"
      }
      if (message.srcSSI == this.$store.state.device.issi){
        return "mdi-upload"
      }
      return "mdi-download"
    },
    get_icon_color(message){
      if (message.system_message){
        return ""
      }
      if (message.srcSSI == this.$store.state.device.issi){
        return "red"
      }
      return "green"
    },
  }
};
</script>

<style scoped>

</style>
